import merge from 'lodash/merge';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import get from 'lodash/get';
import { FETCH_EXPECTATIONS_SUCCESS } from '../actions/expectations';
import {
  FETCH_CONTRACTPRODUCTS_SUCCESS,
  PATCH_CONTRACT_FILTERS_SUCCESS,
  REJECT_CONTRACT_SUCCESS,
} from '../actions/contracts';
import { FETCH_TASKS_SUCCESS, taskSchema } from '../actions/tasks';
import { REMOVE_STATEMENTATTACHMENT } from '../actions/statements';
import { EDIT_ADJUSTMENT_SUCCESS } from '../actions/adjustments';
import { FETCH_USERS_SUCCESS } from '../actions/users';
import { FETCH_KEYWORDS_SUCCESS } from '../actions/keywords';
import { FETCH_STAGED_TRANSACTION_SUMMARY_SUCCESS } from '../actions/driStats';
/**
 * Use a custom merge comparator for lodash, because by default they concat arrays
 * (i.e. products under agreements) and we want them to just overwrite them.
 * i.e. if a user deletes a product from an agreement, it wouldn't reflect in
 * the state because the new smaller array would just combine with the old one.
 */
// eslint-disable-next-line
const mergeOverwriteArrays = (a, b) => {
  if (isArray(a) && isArray(b)) {
    return b;
  }
};

/**
 * Updates an entity cache in response to any action with response.entities.
 * This property is generated by normalizr.
 */
// eslint-disable-next-line default-param-last
export default function entities(state = {}, action) {
  const { payload } = action;

  if (action.type === FETCH_EXPECTATIONS_SUCCESS && payload.entities.expectations) {
    Object.keys(payload.result).map(expectation =>
      merge(payload.entities.expectations, {
        [expectation]: {
          transactionDate: action.meta.transactionDate,
          type: action.meta.type,
          contractId: action.meta.contractId,
          partnerName: action.meta.partnerName,
        },
      }),
    );
  }

  if (action.type === FETCH_CONTRACTPRODUCTS_SUCCESS) {
    return mergeWith({}, state, { productsByAgreements: payload }, mergeOverwriteArrays);
  }

  if (action.type === FETCH_TASKS_SUCCESS) {
    // merge tasks as an array instead of a keyed object so that they ALL get
    // overwritten on every request. this is because when a task is "completed",
    // it won't be returned on subsequent requests, therefore won't be overwritten.
    return mergeWith(
      {},
      state,
      { [taskSchema.key]: Object.values(get(payload, `entities.${taskSchema.key}`, {})) },
      mergeOverwriteArrays,
    );
  }

  if (action.type === REMOVE_STATEMENTATTACHMENT) {
    return {
      ...state,
      statementDetail: {
        ...state.statementDetail,
        [payload.statementId]: {
          ...state.statementDetail[payload.statementId],
          attachments: [
            ...state.statementDetail[payload.statementId].attachments.filter(
              item => item.fileName !== payload.documentName,
            ),
          ],
        },
      },
    };
  }

  if (action.type === FETCH_USERS_SUCCESS && payload.entities) {
    // Override the state with the users
    return {
      ...state,
      users: {
        ...payload.entities.users,
      },
    };
  }

  if (action.type === EDIT_ADJUSTMENT_SUCCESS) {
    // Override the state with the updated adjustment, instead of lodash's mergeWith, which wont consume null fields(reverseDate,actualDate)
    return {
      ...state,
      adjustments: {
        ...state.adjustments,
        ...payload.entities.adjustments,
      },
    };
  }

  if (action.type === PATCH_CONTRACT_FILTERS_SUCCESS) {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        [action.meta.contractAddress]: {
          ...state.contracts[action.meta.contractAddress],
          scopeFilter: {
            dimensions: payload.dimensions,
            filters: payload.updatedFilters,
          },
        },
      },
    };
  }

  if (action.type === FETCH_STAGED_TRANSACTION_SUMMARY_SUCCESS) {
    return {
      ...state,
      stagedTransactionSummary: payload,
    };
  }

  if (action.type === FETCH_KEYWORDS_SUCCESS && payload.entities) {
    // Override the state with the keywords
    return {
      ...state,
      keywords: {
        ...payload.entities.keywords,
      },
    };
  }

  if (action.type === REJECT_CONTRACT_SUCCESS) {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        [action.meta.contractAddress]: {
          ...state.contracts[action.meta.contractAddress],
          ...get(payload, `entities.contracts[${action.meta.contractAddress}]`, {}),
        },
      },
    };
  }

  if (payload && payload.entities) {
    return mergeWith({}, state, payload.entities, mergeOverwriteArrays);
  }

  return state;
}
